import type { IconProps } from '../types/IconProps.ts';
export const UserCheck: IconProps = {
    name: 'UserCheck',
    children: [
        `<circle cx="10" cy="8" r="5" />`,
        `<path d="M15 14.75A8 8 0 0 0 2 21M16 19.33l1.6 1.34a.5.5 0 0 0 .72-.07L22 16" />`,
    ]
};